import { loadingActions } from 'store/loader'
import request from 'utils/request';
import { getStudyVersionID } from '../../../../../../../../../../utils/studyConfigUtils'
import { actions as notyActions } from 'layouts/ErrorBox'
import { generateNotyMessage } from 'utils/request'
import { fetchPtps } from '../../../ParticipantsPage/modules/Participants'

//
// Actions
//
export const LINK_PPTS_AND_CAREGIVERS = 'LINK_PPTS_AND_CAREGIVERS'

export function linkPptsAndCaregivers({ studyID, isParticipantType, id, selectedList }) {
    return (dispatch, getState) => {
        const studyVersionID = getStudyVersionID(getState()?.location)
        const requestBody = { linked_ids: selectedList }
        const success = jsonBody => {
            dispatch(
                notyActions.showSuccess({
                    text: generateNotyMessage('Caregiver assignment updated successfully.'),
                }),
            )

            // Trigger fetchPtps after successful linking
            dispatch(fetchPtps(studyID))
        }

        const fail = (_, content) => {
            dispatch(
                notyActions.showError({
                    text: generateNotyMessage(content?.message || 'There was an error during saving study version notes.', false),
                })
            )
        }

        dispatch(loadingActions.startLoader(true))

        return dispatch(
            request({
                method: 'POST',
                url: `/control/studies/${studyID}/study_version/${studyVersionID}/${isParticipantType ? 'participant' : 'caregiver'}/${id}/link`,
                failMessage: 'There was some technical error. Please try again.',
                success,
                fail,
                hasLoader: true,
                loadingKey: 'caregiver_assignment',
                body: JSON.stringify(requestBody),
            }),
        ).then(() => {
            return dispatch(loadingActions.stopLoader(true))
        })
    }
}

export const actions = {
    linkPptsAndCaregivers
}
